<!-- src/App.vue -->
<template>
  <div id="app" v-if="userLoaded">
    <router-view />
  </div>
</template>

<script>
import environment from '@/config/environment';
import { onMounted, onUnmounted } from "vue";
import $ from "jquery";

export default {
  name: 'MainApp',  

  setup() {
    const handlePopState = () => {
      // Fechar o dropdown do Select2 (não o Select2 inteiro)
      const select2Dropdown = $(".select2-dropdown.select2-dropdown--below");
      if (select2Dropdown.length > 0) {
        select2Dropdown.hide(); // Esconde o dropdown
      }
    };

    onMounted(() => {
      window.addEventListener("popstate", handlePopState); // Escuta o botão de voltar
    });

    onUnmounted(() => {
      window.removeEventListener("popstate", handlePopState); // Limpa o ouvinte ao desmontar
    });
  },
  data() {
    return {
      redirected: false,
      userLoaded: false
    };
  },
  created() {
    if (window.location.pathname === '/acesso_negado') {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    let token = urlParams.get('tokenLaravel');

    if (token) {
      localStorage.setItem('tokenLaravel', token);
    } else {
      token = localStorage.getItem('tokenLaravel');
    }

    if (!token) {
      console.error('Token não encontrado na URL ou no local storage');
      window.location.href = '/acesso_negado';
      return;
    }

    // Chamar o endpoint /validateToken enviando o token como parâmetro via método POST
    fetch(`${environment.apiUrl}validateToken`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ token })
    })
      .then(response => response.json())
      .then(data => {
        if (data.error || !data.user) throw new Error(data.error || 'Token inválido');
        this.$root.user = data.user; // Define o usuário global no $root
        this.$root.token = token;
        this.userLoaded = true; // Indica que o usuário foi carregado
      })
      .catch(() => {
        if (!this.redirected) {
          this.redirected = true;
          window.location.href = '/acesso_negado';
        }
      });

  },
};
</script>
<style>
  :root {
    --cor_principal: #136A9F;
  }

  #app {
    background-color: #f1f5f9;
  }
  .el-select__wrapper.is-filterable, .el-select__wrapper {
    border-radius: .75rem !important;
    height: 66px !important;
  }

  .el-select__wrapper.is-disabled, .el-select__wrapper.is-disabled:hover {
    background: #e9ecef !important;
    font-size: 16px !important;
  }

  .el-select__selected-item {
    font-size: 16px !important;
  }

  span.select2-dropdown.select2-dropdown--below {
      z-index: 9999 !important;
  }

  .select-two .select2-container--default .select2-selection--single .select2-selection__rendered {
    margin-left: 34px !important;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .select-two .select2-container .select2-selection--single, span.select2-selection.select2-selection--multiple {
      margin-bottom: 10px !important;
  }

  .modal-body .select2-container--default .select2-selection--single .select2-selection__rendered {
    margin-top: 8px !important;
  }

  .modal-body .select2-container .select2-selection--multiple .select2-selection__rendered {
    margin-left: 7px;
  }

  .formulario input {
    padding-top: 13px !important;
  } 

  .custom_select option:checked, .custom_select option:hover {
    background-color: #A68B3C !important;
    color: white;
    font-weight: bolder;
  }

  @media not all and (pointer: coarse)
  {
    select#tipoDecisao,
    select#local_decisao,
    select#podeSerVisitado {
      -webkit-appearance: menulist-button;
      cursor: pointer;
    }
  }

  select#tipoDecisao,
  select#local_decisao,
  select#faixaEtaria,
  select#podeSerVisitado {
      padding-top: 10px;
      padding-left: 39px !important;
    }
  input#nomeInput {
    padding-left: 11px !important;
  }

  select:disabled {
    background-color: #e9ecef;
  }


  .formulario hr {
    border: 1px solid black;
  }

  .my-title{
    font-size: 1rem;
    /* font-weight: normal; */
    color: #444444;
    margin-top: 5px;
  }

  .text-danger.error{
    margin-top: -10px;
    padding-top: 0px;
    margin-bottom: 7px;
  }

  /* input:focus {
    box-shadow: 0 0 0 .15rem #136a9f !important;
  } */

  .my-icon {
    transform: translateY(-68%)!important;
  }

  .bi.bi-phone.position-absolute.top-50.start-0.translate-middle-y.ps-3{
    transform: translateY(-70%)!important;
  }

  .el-float-label{
    position: relative !important;
  }

  .el-float-label label{
      position: absolute !important;
      color: rgba(var(--bs-body-color-rgb), .65);
      font-size: 12px;
      z-index: 2;
      left: 12px;
      top: 3px;
  }

  .el-float-label .el-select__wrapper.is-filterable, .el-select__wrapper 
  {
    height: auto !important;
    min-height: 66px !important;
  }

  input#nomeInput {
      padding-left: 0 !important;
  }

  .el-float-label .el-input__wrapper {
    border-radius: .75rem !important;
  }

  .el-float-label .el-select__selection.is-near {
    padding-top: 16px;
  }

  .el-timeline-item__timestamp.is-top {
      font-weight: bolder;
  }

  .el-switch--large .el-switch__label {
    color: rgb(19, 106, 159) !important;
  }

  .el-switch.is-checked .el-switch__core {
      background-color: rgb(19, 106, 159) !important;
      border-color: rgb(19, 106, 159) !important;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: rgb(19, 106, 159) !important;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: rgb(19, 106, 159) !important;
      border-color: rgb(19, 106, 159) !important;
  }

  .el-checkbox.el-checkbox--large .el-checkbox__inner {
      height: 25px !important;
      width: 25px !important;
  }

  .el-checkbox.el-checkbox--large .el-checkbox__label {
    font-size: 1rem !important;
  }

  .el-checkbox__inner:after {
    height: 16px !important;
    left: 10px !important;
    top: 2px !important;
  }
</style>